"use strict";

exports.__esModule = true;
exports["default"] = exports.TestInput = void 0;

var _object = _interopRequireDefault(require("object.omit"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _propValidators = require("../utils/propValidators");

var _forwardRef = _interopRequireDefault(require("../utils/forwardRef"));

var _InputBase = _interopRequireDefault(require("./InputBase"));

var _withId = _interopRequireDefault(require("../utils/withId"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  label: _propValidators.accessibleLabelType.isRequired,
  value: _propTypes["default"].string
};

var Input = function Input(props) {
  return /*#__PURE__*/_react["default"].createElement(_InputBase["default"], (0, _object["default"])(props, 'popup'));
};

Input.propTypes = propTypes;
var TestInput = Input;
exports.TestInput = TestInput;

var _default = (0, _forwardRef["default"])((0, _withId["default"])(Input));

exports["default"] = _default;